export default [
  {
    header: 'warehouses',
    permission: ['admin', 'chief_manager', 'manager', 'foreman']

  },
  {
    title: 'sidebar.masters',
    icon: 'ArchiveIcon',
    route: 'masters',
    permission: ['foreman', 'builder', 'manager']

  },
  {
    title: 'sidebar.remains',
    icon: 'PackageIcon',
    route: 'remains',
    permission: ['admin', 'chief_manager', 'manager', 'foreman']

  },
]
